module.exports = __webpack_public_path__ + "img/passport-green-icon.3757b7d9.svg";